import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const LEGEND_ITEMS = [
  { color: '#12B76A', label: 'Healthy', description: 'Active within 5 days' },
  { color: '#EC4899', label: 'Hot', description: 'Closes within 30 days, prob. >= 50%' },
  { color: '#F79009', label: 'Stalled', description: 'No progression in 6-10 days' },
  { color: '#F04438', label: 'At Risk', description: 'Overdue or 11+ days in stage' },
];

export const DealStatusLegend = () => (
  <Stack direction="row" gap="0.5rem" flexWrap="wrap" alignItems="center" padding="0.5rem">
    {LEGEND_ITEMS.map(({ color, label, description }) => (
      <Stack key={label} direction="row" gap="0.5rem" alignItems="center">
        <Box sx={{ flexShrink: 0, width: '1rem', height: '1rem', borderRadius: '50%', backgroundColor: color }} />

        <Typography>
          {label} - {description}
        </Typography>
      </Stack>
    ))}
  </Stack>
);
